/** Текст ошибки из ответа бэкенда: {message}, карта ошибок валидации {field: msg} или строка. */
export function extractApiError(error: unknown, fallback = "Ошибка запроса"): string {
  const data = (error as { response?: { data?: unknown } })?.response?.data;
  if (typeof data === "string" && data.trim()) {
    return data;
  }
  if (data && typeof data === "object") {
    const record = data as Record<string, unknown>;
    if (typeof record.message === "string") {
      return record.message;
    }
    const messages = Object.values(record).filter((v): v is string => typeof v === "string");
    if (messages.length) {
      return messages.join("; ");
    }
  }
  return fallback;
}
